<div class="row margin-top-16">
  <div class="col-lg-6 input-control">
    <hub-input [(ngModel)]="user.Name" label="{{'general.firstname' | translate}}"
               [autofocus]="true"></hub-input>
  </div>
  <div class="col-lg-6 input-control">
    <hub-input [(ngModel)]="user.Surname" label="{{'general.surname' | translate}}"></hub-input>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 input-control">
    <hub-input [(ngModel)]="user.PhoneNumber" label="{{'onboarding.mobilenumber' | translate}}"></hub-input>
  </div>
</div>
<div class="row">
  <div class="col-lg-12 input-control">
    <hub-input [(ngModel)]="user.Email" label="{{'onboarding.email' | translate}}"></hub-input>
  </div>

</div>
<div class="row margin-top-8" *ngIf="showGDPRMarketingConsent == true">
  <div class="col-md-12" style="display: flex; align-items: center;">
    <hub-checkbox [label]="'bikeshop.modal.update_job_card.job_card.showgdprconsent' | translate" [(ngModel)]="user.GDPRMarketingConsent"
                    [style]="'primary'" [labelExtra]="'bikeshop.modal.update_job_card.job_card.showgdprconsent_info' | translate"
                     ></hub-checkbox>
  </div>
</div>
<div class="row margin-top-16">
  <div class="col-lg-6 input-control">
    <div class="button-container button-container-left" style="justify-content:left">
    </div>
  </div>
  <div class="col-lg-6 input-control">
    <div class="button-container" style="text-align: -webkit-right">

      <div class="row margin-top-16">
        <!--<button pButton type="button" (click)="resetPassword.show($event)"
        class="p-button-raised full-width" label="Reset User Password"></button>-->

        <hub-button *ngIf="isSuperUser" [text]="'onboarding.button.reset_password' | translate"
                    [style]="'primary'"
                    [size]="'xl'"></hub-button>

        <p-overlayPanel #resetPassword [dismissable]="false" [showCloseIcon]="true">
          <ng-template pTemplate="content">
            <app-reset-password [user]="user" [component]="resetPassword"
                                [messageService]="messageService">
            </app-reset-password>
          </ng-template>
        </p-overlayPanel>


        <div style="margin-left:8px;"></div>
        <hub-button [text]="'bikeshop.modal.add_edit_user.user_form.update_user' | translate"
                    [style]="'secondary'" (click)="updateUser()"
                    [size]="'xl'"></hub-button>
      </div>
    </div>
  </div>
</div>
